// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore/lite";
import { getStorage } from "firebase/storage"; // ✅ Import Firebase Storage

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDQywnoMGy3QB-0B51DHW11JTbwS6wavcs",
  authDomain: "wangotrailsafaris-admin.firebaseapp.com",
  projectId: "wangotrailsafaris-admin",
  storageBucket: "wangotrailsafaris-admin.firebasestorage.app", // ✅ Fix the storageBucket URL
  messagingSenderId: "162892709789",
  appId: "1:162892709789:web:a29539bd731807a1af3974",

};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const authentication = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); // ✅ Initialize Firebase Storage
